import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

@Component({
	selector: 'app-sms',
	templateUrl: './sms.component.html',
	styleUrls: ['./sms.component.css']
})
export class SmsComponent implements OnInit {

	admPageObj:any = "curr";

	logi_user:any;

	smsData:any = [];

	frm : FormGroup;

	constructor(
		private http: HttpClient,
		private fb: FormBuilder,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = fb.group({
			send_done: ['0'],
			send_cancel: ['0'],
			user_message: [''],
			user_message2: [''],
			cstel1: [''],
			cstel2: [''],
			cstel3: [''],
			cstel4: ['']
		});
	}

	ngOnInit() {
		this.getSmsData();
	}

	async getSmsData() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);

		this.http.post(this.env.API_URL + 'api/sms.data.php', formData).subscribe((response) => {
			this.smsData = response['data'];

			this.frm.get('send_done').setValue(response['data']['send_done']);
			this.frm.get('send_cancel').setValue(response['data']['send_cancel']);
			this.frm.get('user_message').setValue(response['data']['user_message']);
			this.frm.get('user_message2').setValue(response['data']['user_message2']);
			this.frm.get('cstel1').setValue(response['data']['cstel1']);
			this.frm.get('cstel2').setValue(response['data']['cstel2']);
			this.frm.get('cstel3').setValue(response['data']['cstel3']);
			this.frm.get('cstel4').setValue(response['data']['cstel4']);
		});
	}

	async smsForm() {
		this.logi_user = await this.authService.getToken();

		var formData: any = new FormData();
		formData.append("logi_user", this.logi_user);
		formData.append("logi_code", this.env.COM_CODE);
		formData.append("senddone", this.frm.get('send_done').value);
		formData.append("sendcancel", this.frm.get('send_cancel').value);
		formData.append("usermessage", this.frm.get('user_message').value);
		formData.append("usermessage2", this.frm.get('user_message2').value);
		formData.append("cstel1", this.frm.get('cstel1').value);
		formData.append("cstel2", this.frm.get('cstel2').value);
		formData.append("cstel3", this.frm.get('cstel3').value);
		formData.append("cstel4", this.frm.get('cstel4').value);

		this.func.prcLoading();

		this.http.post(this.env.API_URL + 'api/sms.process.php', formData).subscribe((response) => {
			this.func.closeLoading();
		});
	}

}
